// extracted by mini-css-extract-plugin
module.exports = {"gvMessages":"GVMessages_gvMessages__8E_Iq","warning":"GVMessages_warning__HpDto","error":"GVMessages_error__WTwi_","close":"GVMessages_close__dxHOv"};